import { PastelDarkTheme } from "../.internal/themes/PastelDarkTheme";
export default PastelDarkTheme;
